import { useMemo } from 'react';

export const useWeekends = (data, start) => {
  return useMemo(() => {
    const w = [];
    if (!start) {
      return w;
    }
    for (let i = 6 - start.getDay(); i < data.length; i += 7) {
      w.push([i, i + 1]);
    }
    return w;
  }, [data, start && start.toString()]);
};
